import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import PaymentModal from './components/PaymentModal';
import ScrollSection from './components/ScrollSection';
import About from './components/About';
import Product from './components/Product';
import Advantages from './components/Advantages';
import BrandSection from './components/BrandSection';
import Accordion from './components/Accordion';
import Slider from './components/Slider';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Oferta from './components/Oferta'; // Добавляем страницу Privacy
import Publicoffer from './components/Publicoffer';
import ScrollTopButton from './components/ScrollTopButton';
import VilattePage from './components/VilattePage';
import VilattePromo from './components/VilattePromo';
import VilatteProductPage from './components/VilatteProductPage';
import VilatteCartPage from './components/VilatteCart';

function App() {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);

  const openPaymentModal = () => setIsPaymentOpen(true);
  const closePaymentModal = () => setIsPaymentOpen(false);

  return (
    <Router>
      <div className="app">
        <Header onPaymentClick={openPaymentModal} />
        
        <Routes>
          {/* Главная страница */}
          <Route path="/" element={
            <>
              
              <section id="main">
                <Hero onPaymentClick={openPaymentModal} />
              </section>

              <PaymentModal isOpen={isPaymentOpen} onClose={closePaymentModal} />

              <div className="zero"></div>
              <ScrollSection />

              <div className="zero"></div>
              <BrandSection />

              <div className="zero"></div>
              <Slider />

              <div className="zero"></div>
              <VilattePromo />

              <div className="zero"></div>
              <section id="about">
                <About />
              </section>

              <div className="zero"></div>
              <Product />

              <div className="zero"></div>
              <section id="advantages">
                <Advantages />
              </section>

              <section id="rules">
                <div className="zero"></div>
                <Accordion />
              </section>
            </>
          } />

          {/* Страница Privacy */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/oferta" element={<Oferta />} />
          <Route path="/vilatte" element={<VilattePage />} />
          <Route path="/vilatte/:filterType/:filterSlug" element={<VilattePage />} />
          <Route path="/vilatte/cart" element={<VilatteCartPage />} />
          <Route path="/vilatte/:productId" element={<VilatteProductPage />} />
          {/*<Route path="/publicoffer" element={<Publicoffer />} />*/}
          
        </Routes>

        <Footer />
        <ScrollTopButton />
      </div>
    </Router>
  );
}

export default App;
